import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// Filter subscriptions by TV system (mg_network_system_id=5)
export const subscriptionList = (params = '') => {
	const query = serialize(params)
	const separator = query ? '&' : '?'
	return Http.get(`/plans/subscriptions${query}${separator}filter[mg_network_system_id]=5&include=user,mgNetworkPlan,mgNetworkPlanPricing`)
}
export const subscriptionShow = (id) => Http.get(`/plans/subscriptions/${id}?include=user,mgNetworkPlan,mgNetworkPlanPricing`)
